// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 998 ? "component---src-templates-home-js" : chunkId) + "-" + {"589":"ee5bbf6e2f65e409e309","998":"81bd7916390157a44189"}[chunkId] + ".js";
};